var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('button',{staticClass:"back-to-top",class:{ 'cart-visible': _vm.isCartButtonVisible },on:{"click":_vm.scrollToTop}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }